export const SHARE_ROUTE = 'share/:id';

export const shareRoute = (base: string) => `${base}/${SHARE_ROUTE}`;

export const ROUTES = {
  home: '/',
  signin: '/sign-in',
  signUp: '/sign-up',
  signUpThankYou: '/sign-up/thank-you',
  passwordReset: '/password-reset',
  passwordRestore: '/password-restore',
  cohortMarketingPerformance: '/cohort-marketing-performance',
  calendarInsights: '/calendar-insights',
  datasources: '/datasources',
  userManagement: '/user-management',
  userSettings: '/user-settings',
  cohortRetention: '/cohort-retention',
  roiBreakdown: '/roi-breakdown',
  cohortChart: '/cohort-chart',
  cohortHistoryChart: '/cohort-history-chart',
  calendarChart: '/calendar-chart',
  cohortScanner: '/cohort-scanner',
  productsCatalog: '/products',
  organizationInfo: '/organization',
  dashboards: '/dashboards',
  overview: '/overview',
  presetsPage: '/presets',
  oauthConsent: '/oauth/consent',
  acceptInvite: '/accept-invite',
};
